export default "__VITE_ASSET__Dl3Uxgjn__"